import { Component, Input } from '@angular/core';
import { OffersOfApplication, Promotion } from '../../../../type/result_type';

@Component({
  selector: 'app-bank-promotion',
  templateUrl: './bank-promotion.component.html',
  styleUrls: ['./bank-promotion.component.scss'],
})
export class BankPromotionComponent {
  @Input() promotionData!: Promotion;
  @Input() cardId!: OffersOfApplication['id'];

  showMobileTooltip = false;

  getTextStyles(): { [key: string]: string } {
    if (this.promotionData?.backgroundColor && this.promotionData?.textColor) {
      return {
        'background-color': this.promotionData.backgroundColor,
        'color': this.promotionData.textColor
      };
    }
    return {};
  }

  onTouch(event: TouchEvent) {
    event.preventDefault();
    this.showMobileTooltip = !this.showMobileTooltip;
  }
} 